import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Municipality } from '../../services/Municipality';
import { MunicipalityService } from '../../services/municipality.service';

@Component({
  selector: '[app-svg-use]',
  templateUrl: './svg-use.component.html',
  styleUrls: ['./svg-use.component.scss']
})
export class SvgUseComponent implements OnChanges {
  @Input('width') width: string;
  @Input('height') height: string;
  @Input('app-svg-use') appSvgUse: string;

  private municipality: Municipality;

  normalizedValue: string;

  constructor(private _municipalityService: MunicipalityService) {
    this._municipalityService.currentMunicipality.subscribe((data) => {
      this.municipality = data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { currentValue } = changes['appSvgUse'];

    if (
      this.municipality.clientId !== 41 &&
      /category\/21\.svg/.test(currentValue)
    ) {
      const value = `21-${this.municipality.clientId}.svg`;
      this.normalizedValue = currentValue.replace('21.svg', value);
    } else {
      this.normalizedValue = currentValue;
    }
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/svg-use/svg-use.component.ts